module.exports = __webpack_public_path__ + "static/media/link.47e0c101.jpg";